export default __webpack_public_path__ + "static/media/COAM-Logo.aa123698.svg";